

export class TariffPlanStatusInput implements ITariffPlanStatusInput {
    /** The auto-generated id of the tariff plan  master */
    tariffPlanId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: ITariffPlanStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tariffPlanId = _data["tariffPlanId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TariffPlanStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new TariffPlanStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tariffPlanId"] = this.tariffPlanId;
        data["status"] = this.status;
        return data; 
    }
}

export interface ITariffPlanStatusInput {
    /** The auto-generated id of the tariff plan  master */
    tariffPlanId: number;
    /** The updated status */
    status: number;
}

